export const desktopSize = 100;
export const mobileSize = 80;
